
export const trackOmniClick = (account, events, variables, linkName, linkType = 'o') => {
	const persistVariables = ['eVar2','eVar3','eVar4','eVar5','eVar12','eVar13','prop1','prop2','prop3','prop9','prop10'];
	
	// These are props/eVars that are always tracked for every link across all properties
	const commonLinkTrackVars = [
		'eVar93', // previous page name
		'prop23' // previous page name
	];
	const s = s_gi(account);

	// Assign the common variables and, if there are events, the events to the trackVars
	let trackVars = (commonLinkTrackVars.length > 0 ? commonLinkTrackVars.join(',') : "") + 
		(events.length > 0 ? ",events" : "");

	// Loop over the variables and add the keys to the variable list
	for (const key in variables) {
		if (trackVars.length > 0) {
			trackVars += ",";
		}
		trackVars += key;
	}

	// Set link track vars _THEN_ link track events
	s.linkLeaveQueryString = true;
	s.linkTrackVars = trackVars;
	s.linkTrackEvents = events.length > 0 ? events : "NONE";

	// If you're thinking to yourself this is the most redundant thing ever...
	// Yea, you're kinda right. But you need to specify linkTrackVars in order
	// to specify linkTrackEvents and THEN actual events and eVar/props themselves.
	for (const key in variables) {
		s[key]=variables[key];
	}
	s.events=events;

	// Transmit
	s.tl(true, linkType, linkName);

	// Clear the variables we just set
	for (const key in variables) {
		// Don't delete common link track vars or persistent variables
		if (persistVariables.concat(commonLinkTrackVars).includes(key)) continue
		delete s[key];
	}
	if (events.length > 0) {
		delete s.events;
	}
}

/**
 * This function is used to asynchronously track offsite links that
 * do not require registration.
 * @param trackingUrl The URL to call for tracking
 */
export const trackClick = (trackingUrl) => {
	// if the url we are receiving already has a ? in it, start the fac (Free And Clear) parameter with a &, otherwise, start it with a ?
	if (trackingUrl.indexOf("?") > 0) {
		trackingUrl += "&fac=1";
	} else {
		trackingUrl += "?fac=1";
	}
	$.ajax({
		url: trackingUrl,
		data: ({
			method: "get",
		}),
	});
}


export const exitTracking = (events, variables, linkName) => {
	// These are props/eVars that are always tracked for every link across all properties
	const commonLinkTrackVars = [
		'eVar93', // previous page name
		'prop23' // previous page name
	];
	const s = s_gi(window.s_account);

	// Assign the common variables and, if there are events, the events to the trackVars
	let trackVars = (commonLinkTrackVars.length > 0 ? commonLinkTrackVars.join(',') : "") + 
		(events.length > 0 ? ",events" : "");
	// Loop over the variables and add the keys to the variable list
	for (const key in variables) {
		trackVars += (trackVars.length > 0 ? "," : "") + key;
	}

	// Set link track vars _THEN_ link track events
	s.linkLeaveQueryString = true;
	s.linkTrackVars = trackVars;
	s.linkTrackEvents = events.length > 0 ? events : "NONE";

	// Set the param values
	for (const key in variables) {
		s[key]=variables[key];
	}
	s.events = events;

	s.tl(this, "e", linkName);

	// Clear the variables we just set
	for (const key in variables) {
		// Don't delete common variables
		if (commonLinkTrackVars.includes(key)) continue;
		delete s[key];
	}
	if (events.length > 0) {
		delete s.events;
	}
}

export const buildOmnitureId = (link) => {
	let omnitureId = "";

	// Check the nodes from root to parent for omniture id's
	const nodes = $.makeArray($(link).parents()).reverse();
	$.each(nodes, function(index, value) {
		const oid = $(value).data("omniture-id");
		// The '' make the omniture id a string, in case the oid is a number
		if (oid !== undefined && (""+oid).length > 0) {
			if (omnitureId.length > 0) {
				omnitureId += ":";
			}
			omnitureId += oid;
		}
	});

	// Check the link itself for an id
	const lid = $(link).data("omniture-id");
	if (omnitureId.length > 0) {
		omnitureId += ":";
	}
	omnitureId += lid;

	return omnitureId.toLowerCase();
}
